import { Panel, Toggle } from "rsuite";
import EyeIcon from "shared/Icons/EyeIcon";

interface ParticipantInfoCardProps {
  reg: number;
  teamName: string;
  memberCount: number;
  teamId: number;
  checkedIn?: boolean;
  handleUpdateCheckIn?: (teamId: number, checkedIn: boolean) => void;
  onEdit: (teamId: number) => void;
  isBattleRoyale?: boolean;
}

export default function ParticipantInfoCard({
  reg,
  teamName,
  memberCount,
  teamId,
  checkedIn,
  onEdit,
  handleUpdateCheckIn,
  isBattleRoyale,
}: ParticipantInfoCardProps) {
  return (
    <Panel bodyFill className="participant-info-card-wrapper">
      <div className={`content ${isBattleRoyale ? "br" : "vs"}`}>
        <div>{reg + 1}</div>
        <div>{teamName}</div>
        <div>{memberCount}</div>
        {handleUpdateCheckIn && typeof checkedIn === "boolean" && (
          <div>
            <Toggle
              checked={checkedIn}
              onChange={(value) => handleUpdateCheckIn(teamId, value)}
            />
          </div>
        )}
        <div style={{ cursor: "pointer" }} onClick={() => onEdit(teamId)}>
          <EyeIcon />
        </div>
      </div>
    </Panel>
  );
}
